import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 22 22"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M21 8.896c-.6 0-1 .39-1 .977v.88c0 4.888-4 8.798-9 8.798s-9-3.91-9-8.798 4-8.798 9-8.798c1.3 0 2.5.293 3.7.782.5.195 1.1 0 1.3-.489s0-1.075-.5-1.27C14.1.391 12.6 0 11 0 4.9 0 0 4.79 0 10.753s4.9 10.754 11 10.754 11-4.79 11-10.754v-.88c0-.586-.4-.977-1-.977m-12.3.195a.98.98 0 0 0-1.4 0 .93.93 0 0 0 0 1.369l3 2.933c.2.195.4.293.7.293s.5-.098.7-.293l10-9.776a.93.93 0 0 0 0-1.369.98.98 0 0 0-1.4 0L11 11.34z"
    }, null, -1)
  ]))]))
}
export default { render: render }